import Template from '../../component/Template.js';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';


import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


export default function TeacherCourseMapping() {

  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);
  const [activeSemester, setActiveSemesterId] = useState(null);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [issaved, setissaved] = useState(false);
  const [semester_id, setSemester] = useState([]);

  const [selectedUserOptions, setSelectedUserOptions] = useState({});
  const [getCollegeTeacherData, setCollegeTeacherData] = useState([]);
  const [isFirstSubmit, setFirstSubmit] = useState(false);
  const [facultyMap, setFacultyMap] = useState({});
  const [getISDisciplineCounts, setISDisciplineCounts] = useState([]);

  const tableRef = useRef(null);


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();

  if (isAuth === false) {

    navigate("/ino/");
  }

  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    const fetchActiveEvents = async () => {

      if (admissionYear?.value && semester_id?.value) {

        try {

          const response = await http.get('getActiveEvents', {
            params: { event_id: 30 }
          });

          const matchedEvent = response.data.find(event =>
            event.admission_year === admissionYear.value &&
            event.semester_id === semester_id.value &&
            event.status === "active"
          );

          if (matchedEvent) {
            setActiveSemesterId(matchedEvent.semester_id); // store active semester

          } else {

            setActiveSemesterId(null);
          }
        } catch (error) {

          setActiveSemesterId(null);


        }

      } else {

        setActiveSemesterId(null);

      }

    };

    fetchActiveEvents();
  }, [admissionYear, semester_id]);

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {

        const response = await http.get('/College/getSFASideActiveAdmissionYear');
        const years = response.data
          .filter(year => year.admission_year !== 2025)
          .map((year) => ({
            id: year.id,
            value: year.admission_year,
            label: year.admission_year
          }));

        setAdmissionYears(years);
      } catch (error) {

        setAdmissionYears([]);

        toast.error("Error fetching admission years");
      }
    };
    fetchAdmissionYears();
  }, []);

  const handleAdmissionYearChange = (selectedOption) => {

    setAdmissionYear(selectedOption);
    setSelectedUserOptions({});
    setDisciplineData([]);


  };

  const handleSemesterChange = (selectedOption) => {

    setSemester(selectedOption);
    setSelectedUserOptions({});
    setDisciplineData([]);

  };


  useEffect(() => {

    const fetchData = async () => {

      try {
        const response = await http.get(`/College/getCollegeDisciplinesforINOprince`, {

          params: {
            college_id: cid,
            semester_id: semester_id.value,
            admission_year: admissionYear.value,
          }
        });

        if (!(response?.data?.status_code === 'ERR5')) {
          setDisciplineData(response.data);
        }
      }
      catch (error) {
        setSelectedUserOptions([]);
        setCollegeTeacherData([]);
        toast.error("Error fetching disciplines");
      }
    };

    if (admissionYear?.value && semester_id?.value) {

      fetchData();

    }

  }, [admissionYear, semester_id, issaved]);


  useEffect(() => {

    const getISDisciplineCounts = async () => {

      try {
        const response = await http.get('/College/ISDisciplineCounts', {
          params: {
            semester: semester_id.value,
            admission_year: admissionYear.value,
          }
        });

        setISDisciplineCounts(response.data);


      } catch (error) {

        getISDisciplineCounts([]);
        if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
          toast.error(error.response.data.message);
        }
        else {
          console.error('Error fetching statistics:', error);
          toast.error('Error fetching statistics');
        }

      }
    };


    if (admissionYear?.value && semester_id?.value) {
      getISDisciplineCounts();

    }
  }, [admissionYear, semester_id, issaved]);


  // useEffect(() => {
  //   const getCourseMappingStatusSummary = async () => {

  //     http.get('/College/getCourseMappingStatusSummary', {
  //       params: {

  //         college_id: cid,
  //         admissionyear: admissionYear.value,
  //         semester_id: semester_id.value,

  //       },
  //     }).then((response) => {

  //       setCourseMappingStatusSummaryData(response.data);

  //     }).catch((error) => {

  //       setCourseMappingStatusSummaryData([]);

  //     });
  //   };
  //   if (cid && admissionYear && semester_id.value) {

  //     getCourseMappingStatusSummary();
  //   }


  // }, [admissionYear, semester_id.value, issaved]);


  const handleUserChange = (selectedOption, discipline_name) => {

    setSelectedUserOptions(prev => ({
      ...prev,
      [discipline_name]: selectedOption || []
    }));

  };


  useEffect(() => {

    const fetchCollegeTeachersList = async () => {

      try {
        const response = await http.get(`/College/getCollegeTeacherIno`, {
          params: {

            college_id: cid,
            admissionyear: admissionYear.value,
            semester_id: semester_id.value,

          },
        });

        setCollegeTeacherData(response.data);

        // Create a lookup dictionary to pass to backend
        const facultyMap = {};

        response.data.forEach(u => {
          facultyMap[u.fac_id] = u;   // store full obj by fac_id
        });

        setFacultyMap(facultyMap);

        const selected = {};

        disciplinedata.forEach(discipline => {

          const matchedUsers = response.data.filter(user =>
            user.discipline?.some(d =>
              d.discipline_id === discipline.discipline_id &&
              d.discipline_type === discipline.college_course_type
            )
          );

          if (matchedUsers.length > 0) {

            selected[discipline.discipline_name] = matchedUsers.map(user => ({
              value: user.user_id,
              label: `${user.full_name} - ${user.fac_id} - ${user.mobile_number}`,
              fac_id: user.fac_id
            }));
          }

        });

        setSelectedUserOptions(selected);

        //console.log("selectedUserOptions", selectedUserOptions);

      }
      catch (error) {

        setCollegeTeacherData([]);

        toast.error("Something went wrong");

      }
    };
    if (disciplinedata.length > 0) {

      fetchCollegeTeachersList();
    }

  }, [disciplinedata, issaved]);




  const handlefirstsubmit = () => {

    setFirstSubmit(!isFirstSubmit);

  }
  const handleSubmitData = (e) => {

    e.preventDefault();
    setFirstSubmit(!isFirstSubmit);


    const discipline_data = disciplinedata.filter(discipline => discipline.mapped !== "approved").map(discipline => {

      const selectedUsers = selectedUserOptions[discipline.discipline_name] || [];

      let user_ids = [];

      if (selectedUsers.length > 0) {

        user_ids = selectedUsers.map(user => {
          // get full faculty details using fac_id
          const fullDetails = facultyMap[user.fac_id] || {};

          return {
            user_id: user.value,
            fac_id: user.fac_id,
            ...fullDetails
          };
        });
      } else {

        user_ids = [];
      }

      return {

        discipline_id: discipline.discipline_id,
        discipline_name: discipline.discipline_name,
        discipline_type: discipline.college_course_type,
        user_ids: user_ids

      };
    }); // Skip empty

    const payload = {

      admYear: admissionYear.value,
      semester: semester_id.value,
      discipline_data: discipline_data,

    };

    const saveUserDataForSeat = () => {

      http.post('/College/mapCollegeTeacherIno', payload).then((response) => {

        if (response.data.status_code === 'MSG1') {

          setissaved(!issaved);
          toast.success('Data saved successfully');



        } else {
          toast.error('Failed to save data');
          setissaved(!issaved);

        }
      }).catch((error) => {

        setissaved(!issaved);

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {
          toast.error(message);
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/sfa/"), 5000);
        } else {
          //toast.error(message);
          toast.error("Something went wrong");
        }
      });
    };
    saveUserDataForSeat();

  };

  const handleCancel = () => {
    setFirstSubmit(!isFirstSubmit);
    //window.location.reload();
  }

  const cancelForm = () => {
    window.location.reload();
  };


  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/isoPdfDownload', {
        params: {
          college_id: cid,
          admissionyear: admissionYear.value,
          semester_id: semester_id.value,
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}__Discipline_IS_Mapping - .pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {

      toast.error('Error generating PDF');

    }
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added

    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added

    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
        textAlign: 'left', // added

      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Internship Supervisor - Discipline Mapping </h5>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="card-body">
                        <div className="row justify-content-center">
                          <div className="col-md-12 mb-4">
                            <div className="row">
                              <div className="col-md-6">
                                <label>Admission Year <span className="errorclr">*</span></label>
                                <Select
                                  maxMenuHeight={200}
                                  // menuPlacement="auto"
                                  id="admyear"
                                  name="admyear"
                                  className="form"
                                  styles={customStyles}
                                  options={admissionYears}
                                  value={admissionYear}
                                  onChange={handleAdmissionYearChange}
                                />
                              </div>

                              <div className="col-md-6">
                                <label>Semester <span className="errorclr">*</span></label>
                                <Select
                                  maxMenuHeight={200}
                                  // menuPlacement="auto"
                                  id="semester_id"
                                  name="semester_id"
                                  className="form"
                                  styles={customStyles}
                                  options={[
                                    { value: 4, label: '4' },
                                    // { value: 5, label: '5' }
                                  ]}
                                  value={semester_id}
                                  onChange={handleSemesterChange}
                                />
                              </div>

                            </div>
                          </div>
                        </div>


                        {/* <div className="row g-sm-3 height-equal-2 widget-charts">

                        
                          <div className="col-sm-4">
                            <div className="card small-widget mb-sm-0 bod-line">
                              <div className="card-body primary"> <span className="f-light">Total Courses</span>
                                <div className="d-flex align-items-end gap-1">
                                  <h5>{getCourseMappingStatusSummaryData.total_courses ? getCourseMappingStatusSummaryData.total_courses : '0'}</h5>
                                </div>
                                <div className="bg-gradient">
                                  <svg className="stroke-icon svg-fill">
                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-4">
                            <div className="card small-widget mb-sm-0 bod-line">
                              <div className="card-body primary"> <span className="f-light">Mapped Courses</span>
                                <div className="d-flex align-items-end gap-1">
                                  <h5>{getCourseMappingStatusSummaryData.mapped_courses ? getCourseMappingStatusSummaryData.mapped_courses : '0'}</h5>


                                </div>
                                <div className="bg-gradient">
                                  <svg className="stroke-icon svg-fill">
                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-sm-4">
                            <div className="card small-widget mb-sm-0 bod-line">
                              <div className="card-body primary"> <span className="f-light">Mapping Pending Courses</span>
                                <div className="d-flex align-items-end gap-1">
                                  <h5>{getCourseMappingStatusSummaryData.pending_courses ? getCourseMappingStatusSummaryData.pending_courses : '0'}</h5>

                                </div>
                                <div className="bg-gradient">
                                  <svg className="stroke-icon svg-fill">
                                    <SchoolIcon sx={{ color: '#581f37' }} />
                                  </svg>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div> */}
                        <div className="table-responsive ovrflw" style={{ overflowX: 'auto' }}>
                          <div className="row justify-content-center">
                            <div className="col-md-10 stat-out-bod">
                              <table
                                className="table-striped table-bordered ex-table mb-10"
                                ref={tableRef}
                                id="dataTableBos"
                                width="100%"
                                style={{ textAlign: 'center', tableLayout: 'fixed' }}
                              >
                                <thead>
                                  <tr className="col-cnt-tab-bg-clr" style={{ height: '40px' }}>

                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Total Disciplines
                                    </th>
                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Mapped Disciplines-Pending for Principal Approval
                                    </th>
                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Disciplines Pending Mapping
                                    </th>
                                    <th style={{ textAlign: "center", verticalAlign: "middle", width: '50%' }}>
                                      Principal Approved Mapping
                                    </th>
                                  </tr>

                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{getISDisciplineCounts?.total_disciplines ? getISDisciplineCounts.total_disciplines : '0'}</td>
                                    <td>{getISDisciplineCounts?.mapped_count ? getISDisciplineCounts.mapped_count : '0'}</td>
                                    <td>{getISDisciplineCounts?.not_mapped_count ? getISDisciplineCounts.not_mapped_count : '0'}</td>
                                    <td>{getISDisciplineCounts?.approved_count ? getISDisciplineCounts.approved_count : '0'}</td>

                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>


                        <div className="pgm-map-box mb-4" style={{ zIndex: '1200' }}>

                          {admissionYear && semester_id ? (
                            disciplinedata && disciplinedata.length > 0 ? (
                              <div>

                                <div className="txt-aln-end">
                                  <button
                                    className="lbl2 btn btn-primary mt-3 mb-3"
                                    onClick={() => handleGeneratePDFNew()}
                                    title="Download"
                                  >
                                    <i class="bi bi-arrow-down-square"></i>
                                  </button>
                                </div>
                                <table className="table colap-table table-hover table-striped">
                                  <thead style={{ backgroundColor: "#f8f9fa", color: "#000" }}>
                                    <tr style={{ textAlign: "center" }}>
                                      <th className="bg-primary" width="50%">Disciplines</th>
                                      <th className="bg-primary">Name - UMS ID- Phone No.</th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    {disciplinedata.map((discipline) => {



                                      let isEditable = activeSemester === semester_id.value;

                                      // Determine display text and styling
                                      let displayText = "Not Mapped";
                                      let textColor = "#856404"; // default for Not Mapped
                                      let bgColor = "#fff3cd"; // default for Not Mapped
                                      let borderColor = "#ffeeba"; // default for Not Mapped

                                      if (discipline.mapped === "approved") {

                                        displayText = "Approved Mapping";
                                        textColor = "#155724"; // green
                                        bgColor = "#d4edda";
                                        borderColor = "#c3e6cb";

                                      } else if (discipline.mapped === "mapped") {

                                        displayText = "Mapped";
                                        textColor = "#004085"; // blue for mapped but not approved
                                        bgColor = "#cce5ff";
                                        borderColor = "#b8daff";
                                      }

                                      return (
                                        <tr key={discipline.discipline_id} style={{ textAlign: "center", verticalAlign: "middle", borderBottom: "1px solid #ddd" }}>
                                          <td>
                                            <input
                                              type="text"
                                              id={`discipline_id_${discipline.discipline_id}`}
                                              name={`discipline_id_${discipline.discipline_id}`}
                                              className="form-control ht"
                                              value={discipline.discipline_name}
                                              readOnly
                                            />

                                            <div
                                              style={{
                                                marginTop: "5px",
                                                fontSize: "12px",
                                                padding: "3px 8px",
                                                borderRadius: "4px",
                                                display: "inline-block",
                                                color: textColor,
                                                backgroundColor: bgColor,
                                                border: `1px solid ${borderColor}`
                                              }}
                                            >
                                              {displayText}
                                            </div>
                                          </td>
                                          <td>
                                            <Select
                                              id={`user_id_${discipline.discipline_id}`}
                                              name={`user_id_${discipline.discipline_id}`}
                                              maxMenuHeight={200}
                                              menuPlacement="auto"
                                              styles={customStyles}
                                              className="form-control ht"

                                              options={getCollegeTeacherData.map(user => ({
                                                value: user.user_id,
                                                label: `${user.full_name} - ${user.fac_id} - ${user.mobile_number}`,
                                                fac_id: user.fac_id,
                                              }))}
                                              value={selectedUserOptions[discipline.discipline_name] || null}
                                              onChange={(selectedOption) => {

                                                if (discipline.mapped != "approved") {

                                                  handleUserChange(selectedOption, discipline.discipline_name);
                                                }

                                              }}

                                              isMulti
                                              isDisabled={!isEditable || (discipline.mapped === "approved")}

                                            />
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                                <div>
                                  <p className="txt-aln" style={{ marginTop: '10px', fontSize: '12px', color: 'red' }}>
                                    Please note that after the Principal’s approval of the Internship Supervisor - Discipline Mapping, no further modifications will be allowed.
                                  </p>
                                </div>

                                {/* Only show buttons if selected semester is active */}
                                {activeSemester && !disciplinedata.every(discipline => discipline.mapped === "approved") && (

                                  <div className="col-md-12 txt-aln p-50">
                                    <div>
                                      <button
                                        className="btn btn-primary me-3"
                                        type="submit"
                                        onClick={handlefirstsubmit}
                                      >
                                        Forward to Principal
                                      </button>


                                    </div>
                                  </div>

                                )}

                              </div>
                            ) : (
                              <div style={{ textAlign: 'center' }}>
                                <p>No data found</p>
                              </div>
                            )
                          ) : (
                            <div style={{ textAlign: 'center' }}>
                              <p>No data found</p>
                            </div>
                          )}

                          <div className={`modal fade show ${isFirstSubmit ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                              <div className="modal-content">
                                <div className="modal-body">
                                  <div className="modal-toggle-wrapper">
                                    <h4 className="text-center pb-2">Are you sure you want to save?</h4>
                                    <p className="txt-aln-jst">Please click on 'Save' to save your changes.</p>
                                    <div className="d-flex justify-content-center mt-3">
                                      <div>
                                        <button className="btn btn-danger mx-2" onClick={handleSubmitData}>Save</button>
                                        <button
                                          className="btn"
                                          style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }}
                                          data-bs-dismiss="modal"
                                          onClick={handleCancel}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>




      </Template>
    </>
  );
}
